import { SupportedLanguagesCode, addResourceBundles } from "@/i18n";

import de from "./de.json";
import en from "./en.json";

export const namespace = "DemandScorePanel";

export const demandScoreTranslationKeys = {
  VERY_LOW_DEMAND: "veryLow",
  LOW_DEMAND: "low",
  MODERATE_DEMAND: "moderate",
  HIGH_DEMAND: "high",
  VERY_HIGH_DEMAND: "veryHigh",
} as const;

declare module "i18next" {
  interface CustomTypeResources {
    [namespace]: typeof de;
  }
}

addResourceBundles([
  { languageCode: SupportedLanguagesCode.de, namespace, resources: de },
  { languageCode: SupportedLanguagesCode.en, namespace, resources: en },
]);
